import { useEffect, useState } from 'react';
import {
  Button, Checkbox,
  Text,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { notifications } from '@mantine/notifications';
import { IconCreditCard } from '@tabler/icons-react';
import Page from '@/components/Page';
import { getMutationResult } from '@/helpers/query';
import routes from '@/routes';
import { useFinishProcessMutation } from '@/services/api';
import { getRouteById, routeWithParams } from '@/helpers/routes';
import { ProcessHeader } from '@/components';

const Pay = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useSelector((state) => state.proposal);
  const [apiFinishProcess] = useFinishProcessMutation();
  const [loading, setLoading] = useState(false);
  const [acceptedPayment, setAcceptedPayment] = useState(false);
  const { config } = useSelector((state) => state.user);
  const extraDetails = useSelector((state) => state.proposal.extraDetails);
  const { loanTypeName } = extraDetails;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleContinue = () => {
    // Here you can add validation or form submission logic
    navigate(routeWithParams(getRouteById(routes.newProposal.id, 'success').path, { id }));
  };

  // TODO: This function should be triggered after successful payment
  const finishProcess = async () => {
    setLoading(true);
    try {
      const summaryData = {
        ReturnValue: id,
        ResponeCode: 200,
      };

      const { data } = await getMutationResult(summaryData, apiFinishProcess);

      if (data.success) {
        handleContinue();
      } else {
        notifications.show({
          title: t('globals.error.title'),
          message: t('globals.error.message'),
        });
      }
    } catch (error) {
      notifications.show({
        title: t('globals.error.title'),
        message: t('globals.error.message'),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReturn = () => {
    if (loanTypeName === 'mortgageRefinancing') {
      const path = routeWithParams(routes.newProposal.pages.find((p) => p.id === 'mortgageCycleSummary').path, { id });
      navigate(path);
    } else {
      navigate(routeWithParams(getRouteById(routes.newProposal.id, 'summary').path, { id }));
    }
  };

  return (
    <>
      <ProcessHeader
        headerText={t('pages.payment.title')}
        headerColor="#E0EDFF"
        headerTextColor="#3348FF"
        showReturnButton
        onReturn={handleReturn}
        icon={IconCreditCard}
      >

      </ProcessHeader>

      <Page.Section>
        <Checkbox
          checked={acceptedPayment}
          onChange={(e) => setAcceptedPayment(e.currentTarget.checked)}
          label={
            <Text size="sm" lh={1.5}>
              {t('pages.pay.terms.1')}
              <Text component="span" fw={700}>
                {t('pages.pay.terms.2', { price: config.price })}
              </Text>
              <br></br>
              {t('pages.pay.terms.3')}
            </Text>
          }
        ></Checkbox>
      </Page.Section>

      <Page.Actions>
        <Button
          onClick={finishProcess}
          loading={loading}
          pr={'3rem'}
          pl={'3rem'}
          type="submit"
          disabled={!acceptedPayment}
        >
          {t('pages.pay.continue')}
        </Button>
      </Page.Actions>
    </>
  );
};

export default Pay;
